export class ArrayUtils {

    public static isNotEmpty<T>(array: T[]) {
        return array && array.length > 0
    }

    public static isEmpty<T>(array: T[]) {
        return !ArrayUtils.isNotEmpty(array);
    }
}